"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var create_entity_1 = require("../../utils/create-entity");
var page_details_layout_1 = require("../../components/entities/page-details-layout");
var page_details_banner_1 = require("../../components/entities/page-details-banner");
var graphql_1 = require("../../utils/graphql");
var page_card_1 = require("../../components/entities/page-card");
exports.Page = {
  name: 'Page',
  groupName: 'Content',
  canEmbed: true,
  useConnections: true,
  usePreview: true,
  useSites: true,
  useViews: true,
  autoRoutes: ['details', 'create', 'update', 'list'],
  components: {
    details: page_details_layout_1.PageDetailsLayout,
    banner: page_details_banner_1.PageDetailsBanner,
    card: page_card_1.PageCard
  },
  banner: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      subtitle\n    "], ["\n      subtitle\n    "])))
  },
  filters: {
    fields: {
      types: {
        entityTypeName: 'PageType'
      }
    }
  },
  useConversation: false,
  usePublishStatus: true,
  usePermissions: true,
  useDuplicateCheck: true,
  includeInSearch: true,
  useFollowers: true,
  useModerators: true,
  table: {
    fieldNames: ["info", "path", "updatedBy", "createdBy"]
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      name\n      title\n      slices { name content { text } }\n      sites { name slug }\n    "], ["\n      name\n      title\n      slices { name content { text } }\n      sites { name slug }\n    "])))
  },
  list: {
    resultsVariant: 'grid',
    hasSearch: true,
    // Remove _DEFINITION_ page
    applyFilterState: function (state) {
      return __assign(__assign({}, state || {}), {
        filter: __assign({
          name: {
            ne: "_DEFINITION_"
          }
        }, state.filter || {})
      });
    },
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      openGraph { \n        id date url author image { id url thumbnails { medium { id url } } }\n        description { id html text plain plainTruncated: plain(truncate: { words: 25 }) }\n      }\n      badge\n      parent { ...EntityValueFields }\n      layout { ...EntityValueFields }\n      siblings(auto: true) { ...EntityValueFields }\n      type { ...EntityValueFields }\n      sites { ...EntityValueFields }\n      summary { id text }\n      updatedBy { ...CreatorFields }\n      createdBy { ...CreatorFields }\n      slices { ...EntityValueFields }\n      path\n    "], ["\n      openGraph { \n        id date url author image { id url thumbnails { medium { id url } } }\n        description { id html text plain plainTruncated: plain(truncate: { words: 25 }) }\n      }\n      badge\n      parent { ...EntityValueFields }\n      layout { ...EntityValueFields }\n      siblings(auto: true) { ...EntityValueFields }\n      type { ...EntityValueFields }\n      sites { ...EntityValueFields }\n      summary { id text }\n      updatedBy { ...CreatorFields }\n      createdBy { ...CreatorFields }\n      slices { ...EntityValueFields }\n      path\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      type { ...EntityValueFields }\n      layout { ...EntityValueFields }\n      content { ...ContentNodeFields }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n      themeMode { ...EntityValueFields }\n        \n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      children { ...EntityValueFields }\n      people { ...EntityValueFields }\n      authors { ...EntityValueFields}\n      feedEntries { ...EntityValueFields }\n      featurePages { ...EntityValueFields }\n      marqueePages { ...EntityValueFields }\n      parent { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n      files { ...FileAssetValueFields }\n      slices {\n        id name slug label title pretitle subtitle disabled \n        intro { ...ContentNodeFields }\n        outro { ...ContentNodeFields }\n        layout { ...EntityValueFields }\n\n        entityLayout { ...EntityValueFields }\n        connectedEntities { ...EntityValueFields }\n        \n        bodyFontType { ...EntityValueFields }\n        headerFontType { ...EntityValueFields }\n        viewTarget { ...EntityValueFields }\n        subviewTarget { ...EntityValueFields }\n\n        indicators { ...EntityValueFields }\n        indicatorGroups { ...EntityValueFields }\n        themeMode { ...EntityValueFields }\n        content { ...ContentNodeFields }\n        backgroundImages { ...EntityValueFields }\n        videos { ...EntityValueFields }\n        images { ...EntityValueFields }\n        color { ...EntityValueFields value darkValue }\n        pages { ...EntityValueFields }\n        people { ...EntityValueFields path }\n        links { ...EntityValueFields }\n        organisations { ...EntityValueFields }\n        feedEntries { ...EntityValueFields }\n        backgroundColor { ...EntityValueFields value darkValue }\n        files { ...FileAssetValueFields }\n        icons { ...EntityValueFields }\n\n        challenges { ...EntityValueFields }\n        keyIssues { ...EntityValueFields }\n        topics { ...EntityValueFields }\n        subTopics { ...EntityValueFields }\n        trends { ...EntityValueFields }\n\n        blocks {\n          id name slug title subtitle\n          content { id text }\n          layout { ...EntityValueFields }\n          links { ...EntityValueFields }\n          page { ...EntityValueFields }\n          image { ...EntityValueFields }\n          color { ...EntityValueFields value darkValue }\n        }\n      }\n\n        id slug path upath\n        name \n        title \n        pretitle\n        subtitle\n        titleRich { text }\n        subtitleRich { text }\n        published\n        content { text }\n        options { text }\n        themeMode { slug }\n        bannerThemeMode { slug }\n        openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }\n        intro { plain text }\n        outro { text }\n        orderNumber\n        layout {\n          id name slug component \n        }\n        videos {\n          id name url\n          thumbnail { id url url2x }\n        }\n        imageAssets {\n          id name image { id url url2x type }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          linkedin\n          position\n          photo { id url url2x thumbnails { bubble { url url2x } } type }\n        }\n        embeds {\n          citations {\n            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n          }\n          pages {\n            id name slug path\n            openGraph {\n              title description { plain }\n              image { url url2x thumbnails { bubble { url url2x } } type }\n            }\n          }\n          people {\n            id name slug path\n            organisation { id name }\n            position\n            photo { id url }\n          }\n          imageAssets {\n            id\n            slug\n            image {\n              id url url2x type width height \n            }\n          }\n        }\n        \n        parent {\n          __typename id name path slug title subtitle pretitle \n          content { text }\n          children {\n            __typename id name path slug title subtitle pretitle \n            openGraph { description { text } }\n            intro { text }\n            orderNumber\n            banner {\n              name slug alternateText\n              thumbnail { \n                id url width height \n              }\n            }\n          }\n        }\n        children {\n          __typename id name path slug title subtitle pretitle \n          openGraph { description { text } }\n          intro { text }\n          orderNumber\n          banner {\n            name slug alternateText\n            thumbnail { \n              id url width height \n            }\n          }\n        }\n        banners {\n          id name slug title description { text } alternateText\n          image { \n            id url type width height\n          }\n        }\n        slices {\n          id name slug \n          title\n          disabled\n          created updated\n          outro { text }\n          intro { text }\n          themeMode { slug }\n          entityTypes { id name slug internalName }\n          images {\n            id name slug alternateText description { text }\n            image { \n              id url type width height\n            }\n          }\n          pages {\n            id name path disabled\n          }\n          people {\n            __typename\n            id name slug \n            photo { url url2x type grayscale { id url url2x } }\n            position\n            bio { text html(links: { target: \"_blank\" }) }\n            linkedin\n            organisation { id name }\n          }\n          links {\n            id name url page { path slug }\n          }\n          options { text }\n          files {\n            id\n            name\n            slug\n            file {\n              id\n              url\n            }\n            thumbnail {\n              url\n            }\n          }\n          videos { \n            url \n            openGraph {\n              image { url url2x type thumbnails { card { url url2x } } }\n            }\n          }\n          color { value }\n          backgroundColor { value }\n          backgroundImages {\n            image {\n              url\n            }\n          }\n          blocks {\n            id name slug \n            title \n            subtitle\n            link { id url name }\n            page { id path name }\n            links { id url name }\n            pages { id name }\n            content { text }\n            options { text }\n            image { id name image { url type thumbnails { card { url url2x } } } }\n          }\n          content { text }\n          image { id }\n          layout { id name slug component }\n          organisations {\n            id\n            name\n            url\n            logoInverted { type url }\n            logo { type url }\n          }\n        }\n        \n    "], ["\n      summary { id text }\n      path\n      title\n      subtitle\n      pretitle\n      type { ...EntityValueFields }\n      layout { ...EntityValueFields }\n      content { ...ContentNodeFields }\n      intro { ...ContentNodeFields }\n      outro { ...ContentNodeFields }\n      themeMode { ...EntityValueFields }\n        \n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      children { ...EntityValueFields }\n      people { ...EntityValueFields }\n      authors { ...EntityValueFields}\n      feedEntries { ...EntityValueFields }\n      featurePages { ...EntityValueFields }\n      marqueePages { ...EntityValueFields }\n      parent { ...EntityValueFields }\n      sites { ...EntityValueFields url }\n      files { ...FileAssetValueFields }\n      slices {\n        id name slug label title pretitle subtitle disabled \n        intro { ...ContentNodeFields }\n        outro { ...ContentNodeFields }\n        layout { ...EntityValueFields }\n\n        entityLayout { ...EntityValueFields }\n        connectedEntities { ...EntityValueFields }\n        \n        bodyFontType { ...EntityValueFields }\n        headerFontType { ...EntityValueFields }\n        viewTarget { ...EntityValueFields }\n        subviewTarget { ...EntityValueFields }\n\n        indicators { ...EntityValueFields }\n        indicatorGroups { ...EntityValueFields }\n        themeMode { ...EntityValueFields }\n        content { ...ContentNodeFields }\n        backgroundImages { ...EntityValueFields }\n        videos { ...EntityValueFields }\n        images { ...EntityValueFields }\n        color { ...EntityValueFields value darkValue }\n        pages { ...EntityValueFields }\n        people { ...EntityValueFields path }\n        links { ...EntityValueFields }\n        organisations { ...EntityValueFields }\n        feedEntries { ...EntityValueFields }\n        backgroundColor { ...EntityValueFields value darkValue }\n        files { ...FileAssetValueFields }\n        icons { ...EntityValueFields }\n\n        challenges { ...EntityValueFields }\n        keyIssues { ...EntityValueFields }\n        topics { ...EntityValueFields }\n        subTopics { ...EntityValueFields }\n        trends { ...EntityValueFields }\n\n        blocks {\n          id name slug title subtitle\n          content { id text }\n          layout { ...EntityValueFields }\n          links { ...EntityValueFields }\n          page { ...EntityValueFields }\n          image { ...EntityValueFields }\n          color { ...EntityValueFields value darkValue }\n        }\n      }\n\n        id slug path upath\n        name \n        title \n        pretitle\n        subtitle\n        titleRich { text }\n        subtitleRich { text }\n        published\n        content { text }\n        options { text }\n        themeMode { slug }\n        bannerThemeMode { slug }\n        openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }\n        intro { plain text }\n        outro { text }\n        orderNumber\n        layout {\n          id name slug component \n        }\n        videos {\n          id name url\n          thumbnail { id url url2x }\n        }\n        imageAssets {\n          id name image { id url url2x type }\n        }\n        people {\n          id name slug path\n          organisation { id name }\n          linkedin\n          position\n          photo { id url url2x thumbnails { bubble { url url2x } } type }\n        }\n        embeds {\n          citations {\n            slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n          }\n          pages {\n            id name slug path\n            openGraph {\n              title description { plain }\n              image { url url2x thumbnails { bubble { url url2x } } type }\n            }\n          }\n          people {\n            id name slug path\n            organisation { id name }\n            position\n            photo { id url }\n          }\n          imageAssets {\n            id\n            slug\n            image {\n              id url url2x type width height \n            }\n          }\n        }\n        \n        parent {\n          __typename id name path slug title subtitle pretitle \n          content { text }\n          children {\n            __typename id name path slug title subtitle pretitle \n            openGraph { description { text } }\n            intro { text }\n            orderNumber\n            banner {\n              name slug alternateText\n              thumbnail { \n                id url width height \n              }\n            }\n          }\n        }\n        children {\n          __typename id name path slug title subtitle pretitle \n          openGraph { description { text } }\n          intro { text }\n          orderNumber\n          banner {\n            name slug alternateText\n            thumbnail { \n              id url width height \n            }\n          }\n        }\n        banners {\n          id name slug title description { text } alternateText\n          image { \n            id url type width height\n          }\n        }\n        slices {\n          id name slug \n          title\n          disabled\n          created updated\n          outro { text }\n          intro { text }\n          themeMode { slug }\n          entityTypes { id name slug internalName }\n          images {\n            id name slug alternateText description { text }\n            image { \n              id url type width height\n            }\n          }\n          pages {\n            id name path disabled\n          }\n          people {\n            __typename\n            id name slug \n            photo { url url2x type grayscale { id url url2x } }\n            position\n            bio { text html(links: { target: \"_blank\" }) }\n            linkedin\n            organisation { id name }\n          }\n          links {\n            id name url page { path slug }\n          }\n          options { text }\n          files {\n            id\n            name\n            slug\n            file {\n              id\n              url\n            }\n            thumbnail {\n              url\n            }\n          }\n          videos { \n            url \n            openGraph {\n              image { url url2x type thumbnails { card { url url2x } } }\n            }\n          }\n          color { value }\n          backgroundColor { value }\n          backgroundImages {\n            image {\n              url\n            }\n          }\n          blocks {\n            id name slug \n            title \n            subtitle\n            link { id url name }\n            page { id path name }\n            links { id url name }\n            pages { id name }\n            content { text }\n            options { text }\n            image { id name image { url type thumbnails { card { url url2x } } } }\n          }\n          content { text }\n          image { id }\n          layout { id name slug component }\n          organisations {\n            id\n            name\n            url\n            logoInverted { type url }\n            logo { type url }\n          }\n        }\n        \n    "])))
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'content',
      intro: 'Specify the content of this page here. Note: If you cannot see content here for a {{PAGE}} which clearly has content, check the SLICES tab.'
    }, {
      name: 'slices'
    }, {
      name: 'views'
    }, {
      name: 'titles'
    }, {
      name: 'featured-content',
      intro: 'Setup {{LINKS}} to appear in a banner carousel, or a card grid for this {{PAGE}}.'
    }, {
      name: 'library'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'community'
    }, {
      name: 'options'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      themeMode: {
        type: 'linked',
        description: 'Is there a specific {{THEME_MODE}} this {{PAGE}} should be displayed in on {{SITES}}? If not specified, this will just be the default Light {{THEME_MODE}}. Note: Dark mode is appropriate when you want things to appear "inverted", i.e. a dark background and white text and links.',
        entityTypeName: 'ThemeMode',
        recommended: false,
        fieldSet: 'overview'
      },
      published: {
        type: 'date',
        updateArgs: 'auto: false',
        description: 'When was this {{PAGE}} published? Note: If not specified, the last update of this {{PAGE}} will be taken as the publish date',
        recommended: false
      },
      edited: {
        type: 'date',
        description: 'When was this {{PAGE}} last edited? Note: the record will maintain an Updated date automatically, but this is useful if you\'d like to curate a last edited date for display on a website for example.',
        recommended: false
      },
      thumbnail: {
        type: 'image',
        description: 'Specify a thumbnail for this {{PAGE}}. This will be used as the OpenGraph thumbnail (og:thumbnail) for social sharing.'
      },
      types: {
        type: 'linkedMultiple',
        recommended: false,
        entityTypeName: 'PageType',
        description: 'What type(s) of {{PAGE}} is this?'
      },
      banners: {
        type: 'banner',
        isMulti: true,
        fieldSet: 'overview',
        recommended: false,
        description: 'Provide one or more {{BANNERS}} for this {{PAGE}}, if required'
      },
      bannerThemeMode: {
        label: 'Banner Theme Mode',
        type: 'linked',
        description: "Is there a specific {{THEME_MODE}} for the {{PAGE}} banner? Note: this is useful if you need to prevent text in the banner from changing colors when the theme mode is changed.<br>More specifically, since text is usually inverted to white in dark mode, you should select \"Light\" to always render <i>dark</i> text, or select to \"Dark\" to always render <i>light</i> text.",
        entityTypeName: 'ThemeMode',
        recommended: false,
        fieldSet: 'overview'
      },
      summary: {
        type: 'longText',
        height: '40px',
        description: 'Provide a concise summary of this {{PAGE}} which is shown in cards and listings (this takes priority over Intro and Content for listings).',
        recommended: false
      },
      layout: {
        type: 'linked',
        fieldSet: 'overview',
        label: 'Layout',
        entityTypeName: 'PageLayout',
        description: 'Select an appropriate {{PAGE_LAYOUT}} for this page when used on the web. Note: this does not affect how this page appears in the Platform itself.'
      },
      parent: {
        type: 'parent',
        recommended: false,
        fieldSet: 'overview'
      },
      siblings: {
        type: 'linkedMultiple',
        isOptionDisabled: function (context) {
          return function (option) {
            var id = context.entityData.id;
            return option.value === id;
          };
        },
        label: 'Sibling Pages',
        recommended: false,
        entityTypeName: 'Page',
        description: 'Are there any {{PAGES}} which are logically grouped with this {{PAGE}}? This is useful if you wish to regard this page at the same level in a hierarchy with other {{PAGES}}, but there is no logical parent {{PAGE}}.'
      },
      orderNumber: {
        type: 'int'
      },
      authors: {
        type: 'linkedMultiple',
        label: 'Authors',
        entityTypeName: 'Person',
        fieldSet: 'overview'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        description: 'Select one or more {{ICONS}} to represent this {{PAGE}}'
      },
      colors: {
        type: 'linkedMultiple',
        entityTypeName: 'Color',
        recommended: false
      },
      entityTypes: {
        type: 'linkedMultiple',
        entityTypeName: 'EntityType',
        description: "Does this {{PAGE}} have any associated {{ENTITY_TYPES}}?. This might be useful if the template for this page is intended to display entities of a certain type, and you need to select which to display."
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      intro: {
        type: 'longText',
        height: '80px',
        recommended: false,
        fieldSet: 'content'
      },
      content: {
        type: 'longText',
        height: '300px',
        recommended: true,
        fieldSet: 'content'
      },
      outro: {
        type: 'longText',
        height: '80px',
        fieldSet: 'content',
        recommended: false
      },
      title: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide an alternative title to use if the name field is not sufficient.'
      },
      subtitle: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide a subtitle if required. This is useful if the overall title needs to be broken into two parts.'
      },
      pretitle: {
        type: 'text',
        fieldSet: 'content',
        description: 'Provide a title to display before the actual title. This might be useful for text which groups multiple pages into a section, where you still want the title field to represent the actual page title.'
      },
      titleRich: {
        type: 'longText',
        label: 'Title (Rich)',
        fieldSet: 'content',
        description: 'Provide a rich version of the title if needed. This can be useful, for example, in {{SITE}} banners which use art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      subtitleRich: {
        type: 'longText',
        label: 'Subtitle (Rich)',
        fieldSet: 'content',
        description: 'Provide a rich version of the subtitle if needed. This can be useful, for example, in {{SITE}} banners which use art-directed text, such as forced line-breaks or emphasis of certain words.'
      },
      marqueePages: {
        label: 'Marquee Pages',
        fieldSet: 'content',
        description: 'Does this {{PAGE}} have any other {{PAGES}} which are featured at a top level? Note: not all {{LAYOUTS}} will support Marquee {{PAGES}}.',
        type: 'linkedMultiple',
        entityTypeName: 'Page'
      },
      featurePages: {
        label: 'Feature Pages',
        fieldSet: 'content',
        description: 'Does this {{PAGE}} have any other {{PAGES}} which are featured? Note: not all {{LAYOUTS}} will support Feature {{PAGES}}.',
        type: 'linkedMultiple',
        entityTypeName: 'Page'
      },
      bannerLinks: {
        label: 'Banner Links',
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: 'Setup {{{LINKS}} which might appear in a banner at the top of this {{PAGE}}',
        fieldSet: 'featured-content'
      },
      cardLinks: {
        label: 'Card Links',
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: 'Setup {{{LINKS}} which might appear in a card grid at the top of this {{PAGE}}, underneath any banner links',
        fieldSet: 'featured-content'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      path: {
        type: 'text',
        updateArgs: 'auto: false',
        maxWidth: '600px',
        recommended: false,
        description: 'Provide a custom path to this page when displayed in a {{SITE}}. NB: If not provided, this will be auto-generated based on the name of the page, and the names of any parent pages (and grandparents and so on)',
        fieldSet: 'admin'
      },
      inSidebar: {
        type: 'boolean',
        description: 'If checked, this page will be shown in the platform sidebar underneath the Home link',
        fieldSet: 'admin'
      },
      showOnHome: {
        type: 'boolean',
        description: 'If checked, the content of this page will be shown on the platform home screen as a small panel which can be expanded.',
        fieldSet: 'admin'
      },
      options: {
        type: 'json',
        description: "Add extra options in JSON format. Note: this is intended as a hook for developers to be able to change advanced properties not available in the standard content fields.",
        fieldSet: 'admin'
      },
      feedEntries: {
        type: 'linkedMultiple',
        label: 'Articles',
        entityTypeName: 'FeedEntry',
        fieldSet: 'library',
        description: 'Does this {{PAGE}} have any related {{FEED_ENTRIES}}?'
      },
      imageAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      backgroundImages: {
        type: 'linkedMultiple',
        label: "Background Images",
        entityTypeName: 'ImageAsset',
        fieldSet: 'library'
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        fieldSet: 'community'
      },
      slices: {
        type: 'linkedTable',
        fieldSet: 'slices',
        entityTypeName: 'Slice',
        description: 'In addition to regular content fields, you can edit the content on this page by specifying a series of {{SLICES}}, each with their own layout. Note: Most {{LAYOUTS}} should display standard content first, followed by content inside {{SLICES}}.'
      },
      disabled: {
        type: 'boolean',
        recommended: false,
        description: 'Check to hide this page from the site.',
        fieldSet: 'admin'
      }
    })
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;